import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const pick = (items) => items[Math.floor(Math.random() * items.length)];

const linearLatex = (coefficient, constant) => {
  const coefficientText = coefficient === 1 ? "" : coefficient === -1 ? "-" : String(coefficient);
  const constantText = constant === 0 ? "" : constant > 0 ? `+${constant}` : String(constant);
  return `${coefficientText}x${constantText}`;
};

export function generateTask() {
  let solution;
  let leftCoefficient;
  let rightCoefficient;
  let leftConstant;
  let rightConstant;
  let middle;

  do {
    solution = randomInt(-6, 8);
    leftCoefficient = pick([-2, -1, 1, 2]);
    rightCoefficient = pick([-2, -1, 1, 2]);
    leftConstant = randomInt(-8, 8);
    rightConstant = randomInt(-8, 8);
    const numerator = (leftCoefficient + rightCoefficient) * solution + leftConstant + rightConstant;
    middle = numerator / 2;
  } while (!Number.isInteger(middle) || leftCoefficient + rightCoefficient === 0);

  return {
    type: "ArithmeticMiddleTermEquationTask",
    data: {
      solution,
      middle,
      leftCoefficient,
      rightCoefficient,
      leftConstant,
      rightConstant,
      leftLatex: linearLatex(leftCoefficient, leftConstant),
      rightLatex: linearLatex(rightCoefficient, rightConstant),
    },
  };
}

export function renderTask({ data }) {
  return (
    <div className="space-y-2">
      <p>
        Liczby <InlineMath math={data.leftLatex} />, <InlineMath math={String(data.middle)} /> oraz{" "}
        <InlineMath math={data.rightLatex} /> są kolejnymi wyrazami ciągu arytmetycznego.
      </p>
      <p>Oblicz wartość <InlineMath math="x" />.</p>
    </div>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return <FractionInput label="x" value={userAnswer} onChange={onChange} disabled={disabled} />;
}

export function checkAnswer({ data }, userAnswer) {
  return Number.isFinite(userAnswer?.parsed) && Math.abs(userAnswer.parsed - data.solution) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`x=${data.solution}`} />;
}

export function renderExplanation({ data }) {
  const coefficientSum = data.leftCoefficient + data.rightCoefficient;
  const constantSum = data.leftConstant + data.rightConstant;
  const constantSumLatex = constantSum === 0 ? "" : constantSum > 0 ? `+${constantSum}` : String(constantSum);
  return (
    <div className="space-y-3">
      <p>Środkowy wyraz ciągu arytmetycznego jest średnią arytmetyczną wyrazów sąsiednich.</p>
      <BlockMath math={String.raw`a_n=\frac{a_{n-1}+a_{n+1}}{2}`} />
      <BlockMath math={String.raw`${data.middle}=\frac{(${data.leftLatex})+(${data.rightLatex})}{2}`} />
      <p>Mnożymy równanie przez <InlineMath math="2" /> i redukujemy wyrazy podobne.</p>
      <BlockMath math={`${2 * data.middle}=${coefficientSum}x${constantSumLatex}`} />
      <BlockMath math={`x=${data.solution}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`x=${userAnswer.raw}`} />;
}
